<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>Create a CSS file </strong> <small>Form</small>
            </div>
            <b-form>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="bannername" class="text-info"
                      >Filename: { no empty space allowed }</label
                    >
                    <b-form-input
                      type="text"
                      class="form-control"
                      id="filename"
                      placeholder="Filename: Ex: style.css"
                      v-model="filename"
                      required
                    ></b-form-input>
                    <div
                      class="invalid-feedback d-block"
                      v-show="errors.filename"
                    >
                      {{ errors.filename }}
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="#device" class="text-info">CSS code:</label>
                    <textarea
                      id="csscode"
                      rows="30"
                      cols="50"
                      class="form-control"
                      required="required"
                      v-model="css"
                    ></textarea>
                    <div class="invalid-feedback d-block" v-show="errors.css">
                      {{ errors.css }}
                    </div>
                    <br />
                  </b-form-group>
                  <b-form-group>
                    <b-button
                      class="mr-2"
                      type="submit"
                      size="md"
                      variant="danger"
                      @click.prevent="saveFile"
                      ><i class="fa fa-dot-circle-o"></i> Save</b-button
                    >
                  </b-form-group>
                  <div class="invalid-feedback d-block" v-show="errors.general">
                    {{ errors.general }}
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Create',
  data () {
    return {
      filename: '',
      css: '',
      errors: {},
      available_files: {}
    }
  },
  methods: {
    chechIfFileExist (filename) {
      // verify if file exist
      let available = []

      available = this.available_files.filter((file) => file.name === filename)
      if (available.length === 0) {
        return false
      } else {
        return true
      }
    },

    saveFile () {
      this.errors = {}

      const formData = new FormData()

      if (this.filename) {
        // check if there are empty spaces
        const emptySpaces = this.filename.split(' ')
        if (emptySpaces.length !== 1) {
          this.errors.filename = 'Empty spaces are not allowed!'
        } else {
          // check extension
          const checkExtension = this.filename.split('.')

          if (checkExtension.length === 2) {
            if ((checkExtension[1]).toLowerCase() === 'css') {
              if (!this.chechIfFileExist(this.filename)) {
                formData.append('filename', this.filename)
              } else {
                this.errors.filename = 'Filename already in use. Choose another filename!'
              }
            } else {
              this.errors.filename = `Filename extension .css is required! Suggestion:  ${checkExtension[0]}.css`
            }
          } else {
            this.errors.filename = `Filename extension .css is required! Suggestion:  ${this.filename}.css`
          }
        }

        if (this.css) {
          formData.append('css', this.css)
        } else {
          this.errors.css = 'CSS code is required!'
        }

        if (Object.keys(this.errors).length === 0) {
          this.$http.post(`${this.$api_url}/css/create`, formData)
            .then((data) => {
              if (data.data.message === 'file created succesfully') {
                if (confirm('CSS file created! Navigate to the manage page?')) {
                  this.$router.push('/css/manage')
                } else {
                  this.css = ''
                  this.filename = ''
                  this.loadCSSList()
                }
              }
            }).catch((e) => {
              alert('Something went wrong. Please try again later!')
              this.errors.general = 'Something went wrong. Please try again!'
            })
        } else {
          this.errors.general = 'Check the required fields!'
        }
      } else {
        this.errors.filename = 'Filename is required!'
      }
    },
    loadCSSList () {
      this.$http.get(`${this.$api_url}/scandircss`).then((data) => {
        if (data) {
          this.available_files = data.data.data
        }
      })
    }
  },
  created () {
    this.loadCSSList()
  }
}
</script>

<style scoped>
xmp {
  overflow: auto;
}
</style>
